"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateSpotMarketMarginRatio = exports.castNumberToSpotPrecision = void 0;
const anchor_1 = require("@coral-xyz/anchor");
const types_1 = require("../types");
const spotBalance_1 = require("./spotBalance");
const numericConstants_1 = require("../constants/numericConstants");
function castNumberToSpotPrecision(value, spotMarket) {
    if (typeof value === 'number') {
        return new anchor_1.BN(value * Math.pow(10, spotMarket.decimals));
    }
    else {
        return value.mul(new anchor_1.BN(Math.pow(10, spotMarket.decimals)));
    }
}
exports.castNumberToSpotPrecision = castNumberToSpotPrecision;
function calculateSpotMarketMarginRatio(market, marginCategory, size, balanceType) {
    if ((0, types_1.isVariant)(balanceType, 'deposit')) {
        const assetWeight = (0, spotBalance_1.calculateAssetWeight)(size, market, marginCategory);
        return numericConstants_1.MARGIN_PRECISION.sub(assetWeight).toNumber();
    }
    else {
        const liabilityWeight = (0, spotBalance_1.calculateLiabilityWeight)(size, market, marginCategory);
        return liabilityWeight.sub(numericConstants_1.MARGIN_PRECISION).toNumber();
    }
}
exports.calculateSpotMarketMarginRatio = calculateSpotMarketMarginRatio;
